import React from "react"
import PropTypes from "prop-types"

export default class AuthorizeBtn extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    isAuthorized: PropTypes.bool,
    showPopup: PropTypes.bool,
    getComponent: PropTypes.func.isRequired
  }

  render() {
    let { isAuthorized, showPopup, onClick, getComponent } = this.props

    //must be moved out of button component
    const AuthorizationPopup = getComponent("authorizationPopup", true)

    return (
      <div className="auth-wrapper">
        <button className={isAuthorized ? "btn authorize locked" : "btn authorize unlocked"} onClick={onClick}>
          <span>Authorize</span>
          <svg width="20" height="20" role="img" aria-label={isAuthorized ? "lock in locked position" : "lock in unlocked position"}>
          <title>{isAuthorized ? "lock in locked position" : "lock in unlocked position"}</title>
          <use href={ isAuthorized ? "#locked" : "#unlocked" } xlinkHref={ isAuthorized ? "#locked" : "#unlocked" } />
        </svg>

        </button>
      { showPopup && <AuthorizationPopup /> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/core/components/auth/authorize-btn.jsx